{
  "name": "@weaverse/core",
  "author": "Weaverse Team",
  "description": "Weaverse Core",
  "version": "5.21.2",
  "license": "MIT",
  "main": "dist/index.js",
  "types": "dist/types/index.d.ts",
  "module": "dist/index.mjs",
  "repository": {
    "url": "git+https://github.com/Weaverse/weaverse.git",
    "directory": "packages/core"
  },
  "publishConfig": {
    "access": "public",
    "@weaverse:registry": "https://registry.npmjs.org"
  },
  "files": [
    "dist",
    "src"
  ],
  "engines": {
    "node": ">=18"
  },
  "scripts": {
    "dev": "tsup --watch",
    "build": "tsup && node ../../scripts/build-declarations.mjs",
    "clean": "rimraf dist",
    "typecheck": "tsc --noEmit",
    "test": "vp test --run"
  },
  "tsup": {
    "entry": [
      "src/index.ts"
    ],
    "format": [
      "esm",
      "cjs"
    ],
    "dts": true,
    "sourcemap": true,
    "clean": true,
    "outDir": "dist"
  }
}
